import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=13d158a0"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=13d158a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports